import { connect } from 'react-redux';

import {
  appModalClose,
  appModalOpen,
 } from 'actions';

import View from './';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    appModalClose(payload) {
      dispatch(appModalClose(payload));
    },
    appModalOpen(payload) {
      dispatch(appModalOpen(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/replace-product/container.js